// libraries
import type { FSA, FSAWithMeta, SimpleFSA } from '@makemydeal/dr-browser-utils';
import type { DealHistory } from '@makemydeal/dr-dash-types';

// types
import type { BaggageEntry, OfferResponse } from '@makemydeal/dr-dash-bff-types';
import type { LOCATION_CHANGE } from 'connected-react-router';
import type { SCENARIOS_FETCH_SUCCESS, SCENARIOS_FETCH_FAILURE } from './multiScenarioActionTypes';
import type {
    MAKE_CURRENT,
    MAKE_CURRENT_COMPLETED,
    FETCH_DEALER_REVIEW_BAGGAGE_REQUEST,
    FETCH_DEALER_REVIEW_BAGGAGE_SUCCESS,
    FETCH_DEALER_REVIEW_BAGGAGE_FAILURE
} from './offerActionTypes';

export const FETCH_DEAL_HISTORY_REQUEST = 'FETCH_DEAL_HISTORY_REQUEST';
export const FETCH_DEAL_HISTORY_SUCCESS = 'FETCH_DEAL_HISTORY_SUCCESS';
export const FETCH_DEAL_HISTORY_FAILURE = 'FETCH_DEAL_HISTORY_FAILURE';

export const DEAL_HISTORY_CHECKED = 'DEAL_HISTORY_CHECKED';
export const DEAL_HISTORY_UNCHECKED = 'DEAL_HISTORY_UNCHECKED';

export const SET_DEAL_HISTORY_SCENARIO_DRAWER_DEAL = 'SET_DEAL_HISTORY_SCENARIO_DRAWER_DEAL';

export const DEAL_HISTORY_SELECTED_UPDATE = 'DEAL_HISTORY_SELECTED_UPDATE';

export const ADD_SCENARIOS_HISTORY_TO_STATE = 'ADD_SCENARIOS_HISTORY_TO_STATE';

export const DEAL_HISTORY_OPEN_DRAWER = 'DEAL_HISTORY_OPEN_DRAWER';
export const DEAL_HISTORY_CLOSE_DRAWER = 'DEAL_HISTORY_CLOSE_DRAWER';

export const SET_MAKE_CURRENT_PENDING = 'SET_MAKE_CURRENT_PENDING';
export const CLEAR_MAKE_CURRENT_SUCCESS = 'CLEAR_MAKE_CURRENT_SUCCESS';

export type FetchDealHistorySuccessPayload = OfferResponse[];
export type DealHistoryChangePayload = {
    deal: DealHistory;
};

export type FetchDealHistoryAction = SimpleFSA<typeof FETCH_DEAL_HISTORY_REQUEST>;

export type FetchDealHistorySuccessAction = FSA<typeof FETCH_DEAL_HISTORY_SUCCESS, FetchDealHistorySuccessPayload>;

export type FetchDealHistoryFailureAction = SimpleFSA<typeof FETCH_DEAL_HISTORY_FAILURE>;

export type ScenariosFetchSuccessPayload = {
    scenarios: OfferResponse[];
};

export type ScenariosFetchSuccessAction = FSAWithMeta<
    typeof SCENARIOS_FETCH_SUCCESS,
    ScenariosFetchSuccessPayload,
    { dealXgVersion?: string }
>;

export type DealHistoryCheckedAction = FSA<typeof DEAL_HISTORY_CHECKED, DealHistory>;
export type DealHistoryUnCheckedAction = FSA<typeof DEAL_HISTORY_UNCHECKED, string>;
export type DealHistoryNavigation = FSA<typeof LOCATION_CHANGE, { location: { pathname: string } }>;
export type SetDealHistoryScenarioDrawerDealAction = FSA<typeof SET_DEAL_HISTORY_SCENARIO_DRAWER_DEAL, DealHistory>;

export type DealHistorySelectedUpdate = FSA<typeof DEAL_HISTORY_SELECTED_UPDATE, string>;

export type OpenDealHistoryDrawerAction = SimpleFSA<typeof DEAL_HISTORY_OPEN_DRAWER>;
export type CloseDealHistoryDrawerAction = SimpleFSA<typeof DEAL_HISTORY_CLOSE_DRAWER>;

export type SetMakeCurrentPendingAction = SimpleFSA<typeof SET_MAKE_CURRENT_PENDING>;
export type ClearMakeCurrentSuccessAction = SimpleFSA<typeof CLEAR_MAKE_CURRENT_SUCCESS>;

export type MakeCurrentAction = SimpleFSA<typeof MAKE_CURRENT>;
export type MakeCurrentCompletedAction = SimpleFSA<typeof MAKE_CURRENT_COMPLETED>;

export type BootstrapFailureAction = SimpleFSA<'BOOTSTRAP_FAILURE'>;

export type FetchDealerReviewBaggageAction = SimpleFSA<typeof FETCH_DEALER_REVIEW_BAGGAGE_REQUEST>;
export type FetchDealerReviewBaggagePayload = { baggage?: BaggageEntry[] };
export type FetchDealerReviewBaggageSuccessAction = FSAWithMeta<
    typeof FETCH_DEALER_REVIEW_BAGGAGE_SUCCESS,
    FetchDealerReviewBaggagePayload,
    { announcedVersion?: string }
>;
export type FetchDealerReviewBaggageFailureAction = SimpleFSA<typeof FETCH_DEALER_REVIEW_BAGGAGE_FAILURE>;
export type ScenariosFetchFailureAction = SimpleFSA<typeof SCENARIOS_FETCH_FAILURE>;

export type DealHistoryActions =
    | FetchDealHistoryAction
    | FetchDealHistorySuccessAction
    | FetchDealHistoryFailureAction
    | DealHistoryCheckedAction
    | DealHistoryUnCheckedAction
    | DealHistoryNavigation
    | DealHistorySelectedUpdate
    | ScenariosFetchSuccessAction
    | SetDealHistoryScenarioDrawerDealAction
    | OpenDealHistoryDrawerAction
    | CloseDealHistoryDrawerAction
    | SetMakeCurrentPendingAction
    | ClearMakeCurrentSuccessAction
    | MakeCurrentAction
    | MakeCurrentCompletedAction
    | BootstrapFailureAction
    | ScenariosFetchFailureAction
    | FetchDealerReviewBaggageAction
    | FetchDealerReviewBaggageSuccessAction
    | FetchDealerReviewBaggageFailureAction;
